import { Component } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { ComponentBase } from '@drl/core/component-base';
import { IpsTranslateService } from '@drl/core/localization/ips-translate.service';
import { Role } from '@drl/core/store/models/role.model';
import { SystemStoreFacadeService } from '@drl/core/store/system-store-facade.service';
import { NbDialogRef } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { CountryISO, SearchCountryField, TooltipLabel } from 'ngx-intl-tel-input';

import { User } from '../../../core/auth/models/user.model';
import { UserFacadeService } from '../../../shared/facades/users-facade.service';
import { RoleType, UserStatus } from '@drl/core/enums';
import { ConfirmationService } from 'primeng/api';
import { AsYouType } from 'libphonenumber-js';
import { UserSessionStoreService as StoreService } from '@drl/core/store/user-session-store.service';

@Component({
  selector: 'app-add-new-user',
  templateUrl: './add-new-user.component.html',
  styleUrls: ['./add-new-user.component.scss'],
})
export class AddNewUserComponent extends ComponentBase {
  country = CountryISO.India;
  confirmationKey: string;
  acceptRequest: boolean;

  constructor(
    protected dialogRef: NbDialogRef<AddNewUserComponent>,
    private readonly userFacade: UserFacadeService,
    private readonly systemStoreFacade: SystemStoreFacadeService,
    protected readonly translateSvc: IpsTranslateService,
    private readonly confirmationService: ConfirmationService,
    private readonly store: StoreService,
  ) {
    super();
    this.translate = this.translateSvc.translate;
  }

  translate: TranslateService;
  isPhonePristine = true;
  userForm = new FormGroup({
    phone: new FormControl(undefined, [Validators.required]),
  });

  separateDialCode = true;
  preferredCountries: CountryISO[] = [
    CountryISO.UnitedStates,
    CountryISO.India,
  ];
  SearchCountryField = SearchCountryField;
  TooltipLabel = TooltipLabel;
  CountryISO = CountryISO;

  isEdit = false;
  phoneEditClass() {
    return `${this.isEdit ? 'input-group input-group-edit' : 'input-group'}`;
  }

  user: User;

  loading = false;

  selectedRole: Role;

  roles: Role[];

  updateUserDetailsTitle: string;
  addNewUserTitle: string;
  updateLbl: string;
  addUserTitle: string;
  userUpdatedMsg: string;
  phoneNotValidMsg: string;
  addUserConfirmationLbl: string;
  updateUserConfirmationLbl: string;
  acceptUserConfirmationLbl:string;
  rejectUserConfirmationLbl:string;
  editLbl: string;
  cancelLbl: string;

  private readonly roleTypesAllowed = [
    RoleType.Admin,
    RoleType.CustomerSupport,
    RoleType.Nurse,
    RoleType.Nutritionist,
    RoleType.Others,
    RoleType.Psychologist,
    RoleType.Specialist,
    RoleType.TechSupport,
  ];

  ngOnInit() {
    super.ngOnInit();
    this.setCountry();
    this.getTranslations();
    this._subscriptions.push(
      this.systemStoreFacade.getRoles().subscribe(rolesList => {
        const filterdRoles = rolesList.filter(roleData =>
          this.roleTypesAllowed.includes(roleData.roleType),
        );

        this.roles = filterdRoles.map(role => {
          role.name = this.translateSvc.translate.instant(role.name);
          return role;
        });
        this.selectedRole = filterdRoles[0];
        if (!this.isEdit) {
          this.user.role = filterdRoles[0];
        }
        this.user.role.name = this.translateSvc.translate.instant(
          this.user.role.name,
        );
        const asYouType = new AsYouType();
        asYouType.input(this.user.phone || '');

        this.userForm = new FormGroup({
          phone: new FormControl(
            {
              number: asYouType.getNumber()
                ? asYouType.getNumber().nationalNumber
                : '',
              countryCode: asYouType.getNumber()
                ? asYouType.getNumber().country || 'US'
                : 'US',
            },
            [Validators.required],
          ),
        });

        if (!this.isEdit) {
          this.user.role = filterdRoles[0];
        }
      }),
    );
  }

  setCountry() {
    const countryName = this.store.getCountryName();
    this.country = CountryISO[countryName] || CountryISO.Brazil;
  }

  getTranslations() {
    this.translate
      .get([
        'updateUserDetailsTitle',
        'addNewUserTitle',
        'updateLbl',
        'addUserTitle',
        'userUpdatedMsg',
        'phoneNotValidMsg',
        'addUserConfirmationLbl',
        'updateUserConfirmationLbl',
        'editLbl',
        'cancelLbl',
        "acceptUserConfirmationLbl",
        "rejectUserConfirmationLbl"
      ])
      .subscribe(res => {
        this.updateUserDetailsTitle = res.updateUserDetailsTitle;
        this.addNewUserTitle = res.addNewUserTitle;
        this.updateLbl = res.updateLbl;
        this.addUserTitle = res.addUserTitle;
        this.userUpdatedMsg = res.userUpdatedMsg;
        this.phoneNotValidMsg = res.phoneNotValidMsg;
        this.addUserConfirmationLbl = res.addUserConfirmationLbl;
        this.updateUserConfirmationLbl = res.updateUserConfirmationLbl;
        this.editLbl = res.editLbl;
        this.cancelLbl = res.cancelLbl;
        this.acceptUserConfirmationLbl=res.acceptUserConfirmationLbl
        this.rejectUserConfirmationLbl=res.rejectUserConfirmationLbl
      });
  }

  addUpdateUsersForm(form: NgForm) {
    if (!form.invalid && !this.userForm.invalid) {
      if (this.confirmationKey == 'updateConfirm') {
        this.confirmationService.confirm({
          message: this.isEdit
            ? this.updateUserConfirmationLbl
            : this.addUserConfirmationLbl,
          accept: () => {
            this.addUpdateUser(form);
          },
          key: this.confirmationKey,
        });
      } else if (this.confirmationKey == 'registrationAcceptConfirm') {
        this.confirmationService.confirm({
          message: this.acceptRequest
            ? this.acceptUserConfirmationLbl
            : this.rejectUserConfirmationLbl,
          accept: () => {           
            this.acceptRejectRegistrationRequest(form,this.acceptRequest);            
          },
          key: this.confirmationKey,
        });
      } else {
        // do nothing
      }
    }
  }

  confirmationKeySelect(value: string,accept?:boolean) {
    this.confirmationKey = value;
    this.acceptRequest=accept
  }

  acceptRejectUserRegistration() {}

  addUpdateUser(form: NgForm,statuschange?:boolean): void {
    if (form.invalid) {
      return;
    }

    this.validatePhone();
    this.user.phone = this.user.phone.replace(/\s+/g, '');
    this.user.phone = this.user.phone.replace(/-/g, '');

    this.loading = true;
    if (this.isEdit) {
      if(!statuschange){
        delete this.user.status;
      }
      delete this.user.externalId;
      if (!this.user.email) {
        delete this.user.email;
      }
      if (!this.user.phone) {
        delete this.user.phone;
      }
      if (!this.user.designation) {
        delete this.user.designation;
      }
      if (!this.user.gender) {
        delete this.user.gender;
      }
      if (this.isEdit && this.user.lastLogin && this.user.lastLogin !== null) {
        delete this.user.email;
        delete this.user.username;
      }

      delete this.user.bio;
      delete this.user.lang;
      delete this.user.qualification;
      delete this.user.gender;
      delete this.user.experience;
      delete this.user.photo;

      this.user.roleId = this.user.role.id;
      this.userFacade
        .updateUser(this.user)
        .subscribe(this.successRes, this.failRes);
    } else {
      this.user.roleId = this.user.roleId || this.user.role.id;
      this.userFacade
        .addUser(this.user)
        .subscribe(this.successRes, this.failRes);
    }
  }

  acceptRejectRegistrationRequest(form: NgForm,accept=true) {   
    this.user.status = accept?UserStatus.REGISTERED.toString():UserStatus.REQUEST_REJECTED.toString();
    this.isEdit=true;
    this.addUpdateUser(form,true)
  }

  successRes = () => {
    this.dialogRef.close({
      error: false,
      message: this.userUpdatedMsg,
    });
    this.loading = false;
  };

  failRes = () => {
    this.loading = false;
  };

  validatePhone() {
    if (
      this.userForm.controls.phone.status === 'INVALID' &&
      this.isPhonePristine
    ) {
      throw new Error(this.phoneNotValidMsg);
    }
    this.user.phone =
      this.userForm.value.phone.dialCode + this.userForm.value.phone.number;
  }

  editPhone() {
    this.isPhonePristine = !this.isPhonePristine;
    this.userForm.reset();
  }

  close() {
    this.dialogRef.close();
  }

  get UserStatus() {
    return UserStatus;
  }
}
